import 'client-only';

import { type Brand } from '@/consts/brands';
import {
  type TreatmentCategory,
  TreatmentCategoryIds,
} from '@/consts/treatmentCategories';
import { type ActivateExpressCheckoutData } from '@/types/productSelectionAndCheckout/types';
import { post } from '@/utils/http/client';
import { urls } from '@/utils/urls';

const activateExpressCheckoutTrial = ({
  brand,
  data,
}: {
  brand: Brand;
  data: ActivateExpressCheckoutData;
}): Promise<void> =>
  post(urls[brand].api.applePay.activateExpressCheckoutTrial, data);

const activateExpressCheckoutSubscription = ({
  brand,
  data,
  treatmentCategory,
}: {
  brand: Brand;
  data: ActivateExpressCheckoutData;
  treatmentCategory: TreatmentCategory;
}): Promise<void> =>
  post(urls[brand].api.applePay.activateExpressCheckoutSubscription, {
    treatmentCategoryId: TreatmentCategoryIds[treatmentCategory],
    ...data,
  });

export const ApplePayService = {
  activateExpressCheckoutTrial,
  activateExpressCheckoutSubscription,
};
